import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Query {
  expand: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, query?: Query) =>
    makeCall<Conversation>('GET', `/api/v2/conversation/${conversationId}`, {
      query,
    });
